import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/mktv-web-react-next/src/app/_components/footer/index.tsx");
